var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"editHeader"},[_c('e-link',{attrs:{"to":_vm.backTo,"arrow":"before"}},[_vm._v("Retour")]),_c('span',{staticClass:"editHeader__separator"},[_vm._v("|")]),_c('h1',{staticClass:"e-h1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }